import * as React from 'react'
import * as R from 'ramda'
import {Step3State} from './Step3State'
import {Step3SubAction} from './Step3Actions'
import Card from 'material-ui/Card/Card'
import Checkbox from 'material-ui/Checkbox'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import {countries, Country} from '../../../Entities/Country'
import MenuItem from 'material-ui/MenuItem'
import creiosTheme from '../../../Theme/creiosTheme'
import injectSheet from 'react-jss'
import {card} from '../../../Style'

const styles = {
    root: {
        display: 'flex',
        justifyContent: 'center'
    },
    collectedInput: {
        display: 'flex',
        flexDirection: 'row'

    },
    ...card
}

interface Props {
    readonly state: Step3State,
    readonly dispatch: (action: Step3SubAction) => void,
}

export const Step3View =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch}) => (
            <div className={classes.root}>
                <Card
                    className={classes.card}
                    style={{
                        maxWidth: '1536px'
                    }}
                >
                    <div className={classes.cardRow}>
                        <div className={classes.cardColumn}>
                            <h2 className={classes.cardHeader}>
                                Rechnungsadresse
                            </h2>
                            <div className={classes.cardContent}>
                                <Checkbox
                                    label="Lieferung an Rechnungsadresse"
                                    labelPosition="right"
                                    labelStyle={{color: creiosTheme.palette.primary1Color}}
                                    style={{marginBottom: '40px'}}
                                    checked={state.input.deliverToInvoiceAddress}
                                    onCheck={(event, value) => dispatch({
                                        type: 'DeliverToInvoiceAddressChanged',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Umsatzsteuer-Nr."
                                    value={state.input.vatId}
                                    onChange={(event, value) => dispatch({
                                        type: 'VatIdChanged',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Name 1"
                                    value={state.input.invoiceName1}
                                    onChange={(event, value) => dispatch({
                                        type: 'InvoiceName1Changed',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Name 2"
                                    value={state.input.invoiceName2}
                                    onChange={(event, value) => dispatch({
                                        type: 'InvoiceName2Changed',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Name 3"
                                    value={state.input.invoiceName3}
                                    onChange={(event, value) => dispatch({
                                        type: 'InvoiceName3Changed',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Name 4"
                                    value={state.input.invoiceName4}
                                    onChange={(event, value) => dispatch({
                                        type: 'InvoiceName4Changed',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Straße"
                                    value={state.input.invoiceStreet}
                                    onChange={(event, value) => dispatch({
                                        type: 'InvoiceStreetChanged',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Hausnummer"
                                    value={state.input.invoiceHouseNumber}
                                    onChange={(event, value) => dispatch({
                                        type: 'InvoiceHouseNumberChanged',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="PLZ"
                                    value={state.input.invoiceZipCode}
                                    onChange={(event, value) => dispatch({
                                        type: 'InvoiceZipCodeChanged',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Ort"
                                    value={state.input.invoiceCity}
                                    onChange={(event, value) => dispatch({
                                        type: 'InvoiceCityChanged',
                                        value
                                    })}
                                />
                                <SelectField
                                    floatingLabelText="Land"
                                    floatingLabelFixed={true}
                                    fullWidth={true}
                                    value={state.input.invoiceCountry}
                                    onChange={
                                        (event, index, value: Country) => dispatch({
                                            type: 'InvoiceCountryChanged',
                                            value
                                        })}
                                >
                                    {R.map(
                                        country =>
                                            <MenuItem
                                                primaryText={country.name}
                                                value={country}
                                                key={country.code}
                                            />,
                                        countries)}
                                </SelectField>
                            </div>
                        </div>
                        <div className={classes.divider}/>
                        <div className={classes.cardColumn}>
                            <h2 className={classes.cardHeader}>
                                Lieferadresse
                            </h2>
                            <div className={classes.cardContent}>
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Name 1"
                                    disabled={state.input.deliverToInvoiceAddress}
                                    value={state.input.deliverToInvoiceAddress
                                        ? state.input.invoiceName1 : state.input.deliveryName1}
                                    onChange={(event, value) => dispatch({
                                        type: 'DeliveryName1Changed',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Name 2"
                                    disabled={state.input.deliverToInvoiceAddress}
                                    value={state.input.deliverToInvoiceAddress
                                        ? state.input.invoiceName2 : state.input.deliveryName2}
                                    onChange={(event, value) => dispatch({
                                        type: 'DeliveryName2Changed',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Name 3"
                                    disabled={state.input.deliverToInvoiceAddress}
                                    value={state.input.deliverToInvoiceAddress
                                        ? state.input.invoiceName3 : state.input.deliveryName3}
                                    onChange={(event, value) => dispatch({
                                        type: 'DeliveryName3Changed',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Name 4"
                                    disabled={state.input.deliverToInvoiceAddress}
                                    value={state.input.deliverToInvoiceAddress
                                        ? state.input.invoiceName4 : state.input.deliveryName4}
                                    onChange={(event, value) => dispatch({
                                        type: 'DeliveryName4Changed',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Straße"
                                    disabled={state.input.deliverToInvoiceAddress}
                                    value={state.input.deliverToInvoiceAddress
                                        ? state.input.invoiceStreet : state.input.deliveryStreet}
                                    onChange={(event, value) => dispatch({
                                        type: 'DeliveryStreetChanged',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Hausnummer"
                                    disabled={state.input.deliverToInvoiceAddress}
                                    value={state.input.deliverToInvoiceAddress
                                        ? state.input.invoiceHouseNumber : state.input.deliveryHouseNumber}
                                    onChange={(event, value) => dispatch({
                                        type: 'DeliveryHouseNumberChanged',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Etage"
                                    value={state.input.deliveryFloor}
                                    onChange={(event, value) => dispatch({
                                        type: 'DeliveryFloorChanged',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Raum"
                                    value={state.input.deliveryRoom}
                                    onChange={(event, value) => dispatch({
                                        type: 'DeliveryRoomChanged',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="PLZ"
                                    disabled={state.input.deliverToInvoiceAddress}
                                    value={state.input.deliverToInvoiceAddress
                                        ? state.input.invoiceZipCode : state.input.deliveryZipCode}
                                    onChange={(event, value) => dispatch({
                                        type: 'DeliveryZipCodeChanged',
                                        value
                                    })}
                                />
                                <TextField
                                    fullWidth={true}
                                    floatingLabelText="Ort"
                                    disabled={state.input.deliverToInvoiceAddress}
                                    value={state.input.deliverToInvoiceAddress
                                        ? state.input.invoiceCity : state.input.deliveryCity}
                                    onChange={(event, value) => dispatch({
                                        type: 'DeliveryCityChanged',
                                        value
                                    })}
                                />
                                <SelectField
                                    floatingLabelText="Land"
                                    floatingLabelFixed={true}
                                    fullWidth={true}
                                    disabled={state.input.deliverToInvoiceAddress}
                                    value={state.input.deliverToInvoiceAddress
                                        ? state.input.invoiceCountry : state.input.deliveryCountry}
                                    onChange={
                                        (event, index, value: Country) => dispatch({
                                            type: 'DeliveryCountryChanged',
                                            value,
                                        })}
                                >
                                    {R.map(
                                        country =>
                                            <MenuItem
                                                primaryText={country.name}
                                                value={country}
                                                key={country.code}
                                            />,
                                        countries)}
                                </SelectField>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>)
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderCreate/Step3/Step3View.tsx